import { defineMessages } from "react-intl";

export const generalMessages = defineMessages({
  "general.notifications": {
    id: "general.notifications",
    defaultMessage: "Notifications",
  },
  "general.new-message-from": {
    id: "general.new-message-from",
    defaultMessage: "New message from {from}",
  },
  "general.message-from": {
    id: "general.message-from",
    defaultMessage: "Message from {from}",
  },
  "general.edit": {
    id: "general.edit",
    defaultMessage: "Edit",
  },
  "general.copy": {
    id: "general.copy",
    defaultMessage: "Copy",
  },
  "general.delete": {
    id: "general.delete",
    defaultMessage: "Delete",
  },
  "general.cancel": {
    id: "general.cancel",
    defaultMessage: "Cancel",
  },
  "general.decline": {
    id: "general.decline",
    defaultMessage: "Decline",
  },
  "general.export.csv": {
    id: "general.export.csv",
    defaultMessage: "Export CSV",
  },
  "general.delimiter": {
    id: "general.delimiter",
    defaultMessage: "Delimiter {delimiter}",
  },
  "general.today": {
    id: "general.today",
    defaultMessage: "Today",
  },
  "general.back": {
    id: "general.back",
    defaultMessage: "Back",
  },
  "general.submit": {
    id: "general.submit",
    defaultMessage: "Submit",
  },
  "general.close": {
    id: "general.close",
    defaultMessage: "Close",
  },
  "general.private": {
    id: "general.private",
    defaultMessage: "Private",
  },
  "general.draft": {
    id: "general.draft",
    defaultMessage: "Draft",
  },
  "general.save": {
    id: "general.save",
    defaultMessage: "Save",
  },
  "general.saved": {
    id: "general.saved",
    defaultMessage: "Saved",
  },
  "general.save-draft": {
    id: "general.save-draft",
    defaultMessage: "Save draft",
  },
  "general.or": {
    id: "general.or",
    defaultMessage: "or",
  },
  "general.loading": {
    id: "general.loading",
    defaultMessage: "Loading",
  },
  "general.unsaved-changes.title": {
    id: "general.unsaved-changes.title",
    defaultMessage: "You have unsaved changes",
  },
  "general.unsaved-changes.close": {
    id: "general.unsaved-changes.close",
    defaultMessage: "Return back",
  },
  "general.unsaved-changes.leave": {
    id: "general.unsaved-changes.leave",
    defaultMessage: "Leave anyway",
  },
  "general.browser-timezone-warning": {
    id: "general.browser-timezone-warning",
    defaultMessage:
      "Timezone on your machine ({browserTz}) seems different than in your profile ({userTz}). You can change it in {linkToSettings}",
  },
  "general.general-settings": {
    id: "general.general-settings",
    defaultMessage: "General Settings",
  },
  "general.regenerate": {
    id: "general.regenerate",
    defaultMessage: "Regenerate",
  },
  "general.the-least": {
    id: "general.the-least",
    defaultMessage: "The least",
  },
  "general.the-most": {
    id: "general.the-most",
    defaultMessage: "The most",
  },
  "general.hide": {
    id: "general.hide",
    defaultMessage: "Hide",
  },
  "general.yes": {
    id: "general.yes",
    defaultMessage: "Yes",
  },
  "general.no": {
    id: "general.no",
    defaultMessage: "No",
  },
  "general.type-something": {
    id: "general.type-something",
    defaultMessage: "Type something",
  },
  "general.username": {
    id: "general.username",
    defaultMessage: "Username",
  },
  "general.confirm": {
    id: "general.confirm",
    defaultMessage: "Confirm",
  },
  "general.add": {
    id: "general.add",
    defaultMessage: "Add",
  },
  "general.other": {
    id: "general.other",
    defaultMessage: "Other",
  },
});
